import Axios from "axios";
import fileDownload from "js-file-download";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../../../../../../../../config";
import tools from "../../../../../../../../../helpers/tools";

const DownloadDocument = ({ document, name, companyName, productName }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isViewing, setIsViewing] = useState(false);

  const downloadFile = () => {
    if (isDownloading) return false;
    setIsDownloading(true);
    Axios({
      url: `${API_URL}files/${document.id}`,
      method: "GET",
      responseType: "blob",
    })
      .then((res) => {
        var filename = tools.getDocumentName({
          fileExt: res.headers["content-disposition"].split(".")[1],
          documentName: document.fileType.name,
          productName,
          companyName,
          uploadedAt: document.uploadedAt,
        });
        fileDownload(res.data, filename);
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          toast.error(err.response.data.other);
        }
      })
      .then(() => {
        setIsDownloading(false);
      });
  };

  const viewFile = () => {
    if (isViewing) return false;
    setIsViewing(true);

    // Récupérer le fichier comme blob pour l'afficher dans le navigateur
    Axios({
      url: `${API_URL}files/${document.id}`,
      method: "GET",
      responseType: "blob",
    })
      .then((res) => {
        // Créer un blob URL pour afficher le PDF dans le navigateur
        const blob = new Blob([res.data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);

        // Ouvrir dans un nouvel onglet
        const newWindow = window.open(blobUrl, "_blank");

        // Nettoyer l'URL blob après un délai pour libérer la mémoire
        if (newWindow) {
          newWindow.addEventListener("beforeunload", () => {
            URL.revokeObjectURL(blobUrl);
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          toast.error(err.response.data.other);
        } else {
          toast.error("Erreur lors de l'ouverture du document");
        }
      })
      .then(() => {
        setIsViewing(false);
      });
  };

  return document ? (
    <div className="d-flex mb-2" style={{ gap: 5 }}>
      <button
        className={
          "btn btn-primary font-weight-bold btn-sm d-flex align-items-center justify-content-center px-3"
        }
        style={{ height: 29, fontSize: 14 }}
        onClick={downloadFile}
        disabled={isDownloading}
      >
        <i
          className={`fa ${
            isDownloading ? "fa-spinner fa-spin" : "fa-download"
          } mr-2`}
        />
        {isDownloading ? "Téléchargement..." : name}
      </button>

      <button
        className={
          "btn btn-outline-primary font-weight-bold btn-sm d-flex align-items-center justify-content-center px-3"
        }
        style={{ height: 29, fontSize: 14 }}
        onClick={viewFile}
        disabled={isViewing}
        title="Visualiser dans un nouvel onglet"
      >
        <i className={`fa ${isViewing ? "fa-spinner fa-spin" : "fa-eye"}`} />
      </button>
    </div>
  ) : null;
};

export default DownloadDocument;
